import React, { useMemo, useState } from "react";
import { FullSchedule, ScheduleRow } from "./types";
import ArrowDown from "../../assets/icons/ArrowDown";
import Edit from "../../assets/icons/Edit";
import Delete from "../../assets/icons/Delete";
import scheduleV2 from "./scheduleV2.json";

interface ScheduleColumn {
  label: string;
  additionalClassName: string;
  key: string;
}

interface ScheduleTableProps {
  onEdit?: (row: ScheduleRow) => void;
  onDelete?: (row: ScheduleRow) => void;
  data?: any[];
  searchQuery?: string;
  sortBy?: keyof ScheduleRow;
  sortDir?: "asc" | "desc";
}

const scheduleColumns: ScheduleColumn[] = [
  { label: 'Ф.И.О. преподавателя', additionalClassName: '', key: 'teacher' },
  { label: 'Шифр дисц.', additionalClassName: '', key: 'disciplineCode' },
  { label: 'Название дисциплины', additionalClassName: '', key: 'disciplineName' },
  { label: 'Специальности', additionalClassName: '', key: 'specialties' },
  { label: 'Тип зан.', additionalClassName: '', key: 'lessonType' },
  { label: 'Название класса', additionalClassName: '', key: 'day' },
  { label: 'Аудитория', additionalClassName: '', key: 'auditorium' },
  { label: 'Кол-во', additionalClassName: '', key: 'count' },
  { label: '', additionalClassName: 'text-center', key: 'actions' },
];

const mockData: FullSchedule = scheduleV2

// const mockData: FullSchedule = [
//   {
//     "school": "Факультет информационных технологий",
//     "schedule": [
//       {
//         "teacher": "Иванов И.И.",
//         "disciplineCode": "CS101",
//         "disciplineName": "Программирование",
//         "specialties": "Программная инженерия",
//         "lessonType": "Лекц.",
//         "day": "Mon",
//         "time": "10:00-12:00",
//         "auditorium": "101",
//         "count": 30
//       },
//       {
//         "teacher": "Петров П.П.",
//         "disciplineCode": "CS102",
//         "disciplineName": "Базы данных",
//         "specialties": "Программная инженерия",
//         "lessonType": "Паркт.",
//         "day": "Wed",
//         "time": "12:00-14:00",
//         "auditorium": "102",
//         "count": 25
//       }
//     ]
//   },
//   {
//     "school": "Факультет информационных технологий 2",
//     "schedule": [
//       {
//         "teacher": "Иванов И.И.",
//         "disciplineCode": "CS101",
//         "disciplineName": "Программирование",
//         "specialties": "Программная инженерия",
//         "lessonType": "Лекц.",
//         "day": "Mon",
//         "time": "10:00-12:00",
//         "auditorium": "101",
//         "count": 30
//       },
//       {
//         "teacher": "Петров П.П.",
//         "disciplineCode": "CS102",
//         "disciplineName": "Базы данных",
//         "specialties": "Программная инженерия",
//         "lessonType": "Паркт.",
//         "day": "Wed",
//         "time": "12:00-14:00",
//         "auditorium": "102",
//         "count": 25
//       }
//     ]
//   },
// ];

export default function ScheduleTable({
  onEdit,
  onDelete,
  data,
  searchQuery = "",
  sortBy,
  sortDir = "asc",
}: ScheduleTableProps) {
  const [expandedSchools, setExpandedSchools] = useState<Record<number, boolean>>({});

  const transitionClasses = {
    schoolToggle: "transition-all duration-300 ease-in-out",
    buttonHover: "transition-opacity duration-200 ease-in-out",
    rowHover: "transition-colors duration-200 ease-in-out",
    arrowRotation: "transition-transform duration-300 ease-in-out"
  };

  const toggleSchool = (schoolIndex: number): void => {
    setExpandedSchools((prev) => ({
      ...prev,
      [schoolIndex]: !prev[schoolIndex],
    }));
  };

  const source = data ?? mockData;

  const rawData = data

  const processedData = []

  // const processedData = useMemo<FullSchedule>(() => {
  //   const q = searchQuery.trim().toLowerCase();
  //   const filtered = source.map(section => ({
  //     ...section,
  //     schedule: section.schedule.filter((r) => {
  //       if (!q) return true;
  //       return [
  //         r.teacher,
  //         r.disciplineCode,
  //         r.disciplineName,
  //         r.specialties,
  //         r.lessonType,
  //         r.day,
  //         r.time,
  //         r.auditorium,
  //         String(r.count),
  //       ].some(val => String(val ?? '').toLowerCase().includes(q));
  //     })
  //   }));

  //   if (!sortBy) return filtered;

  //   const sorted = filtered.map(section => ({
  //     ...section,
  //     schedule: [...section.schedule].sort((a, b) => {
  //       const av = (a[sortBy] as any) ?? '';
  //       const bv = (b[sortBy] as any) ?? '';
  //       if (typeof av === 'number' && typeof bv === 'number') {
  //         return sortDir === 'asc' ? av - bv : bv - av;
  //       }
  //       const as_ = String(av).toLowerCase();
  //       const bs = String(bv).toLowerCase();
  //       if (as_ < bs) return sortDir === 'asc' ? -1 : 1;
  //       if (as_ > bs) return sortDir === 'asc' ? 1 : -1;
  //       return 0;
  //     })
  //   }));

  //   return sorted;
  // }, [source, searchQuery, sortBy, sortDir]);

  const renderButtons = (row: ScheduleRow) => {
    return (
      <div className="flex items-center justify-center gap-2">
        <button
          type="button"
          className={`h-6 w-6 p-1 rounded text-valley-gray opacity-20 hover:opacity-100 bg-valley-gray/20 ${transitionClasses.buttonHover}`}
          onClick={(e) => {
            e.stopPropagation();
            onEdit ? onEdit(row) : console.log('edit', row);
          }}
        >
          <Edit />
        </button>
        <button
          type="button"
          className={`h-6 w-6 p-1 rounded text-valley-red opacity-20 hover:opacity-100 bg-valley-red/20 ${transitionClasses.buttonHover}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete ? onDelete(row) : console.log('delete', row);
          }}
        >
          <Delete />
        </button>
      </div>
    )
  }

  return (
    <div className="w-full">
      {/* Десктопная версия */}
      <div className="hidden lg:block overflow-x-auto">
        <div className="max-h-[70vh] overflow-y-auto mt-4 rounded-lg ">
          <table className="w-full border-collapse text-sm font-medium table-fixed">
            <colgroup>
              <col style={{ width: '14%' }} /> {/* Ф.И.О. преподавателя */}
              <col style={{ width: '6%' }} /> {/* Шифр дисц. */}
              <col style={{ width: '15%' }} /> {/* Название дисциплины */}
              <col style={{ width: '21%' }} /> {/* Специальности */}
              <col style={{ width: '6%' }} /> {/* Тип зан. */}
              <col style={{ width: '15%' }} /> {/* День */}
              <col style={{ width: '8%' }} /> {/* Аудитория */}
              <col style={{ width: '7%' }} /> {/* Кол-во */}
              <col style={{ width: '8%' }} /> {/* Действия */}
            </colgroup>
            <thead className="sticky top-0 bg-white z-10">
              <tr className="bg-white">
                {scheduleColumns.map((column, index) => (
                  <th
                    key={index}
                    className={`text-valley-gray font-medium px-3 py-2 border-b text-left align-middle whitespace-normal break-words ${column.additionalClassName ?? ''}`}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rawData?.map((teacherClass) => (
                <tr key={teacherClass.id} className={`bg-white hover:bg-gray-50 align-top text-sm text-black font-medium ${transitionClasses.rowHover}`}>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{teacherClass.course.teacher.json_saved_data.lastname} {teacherClass.course.teacher.json_saved_data.firstname}</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">-</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{teacherClass.course.name}</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">-</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">-</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{teacherClass.name}</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words">-</td>
                  <td className="px-3 py-2 border-b align-top whitespace-normal break-words text-center">-</td>
                  <td className="px-3 py-2 border-b align-top">
                  </td>
                </tr>
              ))}
              {/* {processedData.map((school, schoolIndex) => (
                <React.Fragment key={schoolIndex}>
                  <tr
                    className={`bg-gray-100 cursor-pointer hover:bg-gray-200 ${transitionClasses.rowHover}`}
                    onClick={() => toggleSchool(schoolIndex)}
                  >
                    <td colSpan={scheduleColumns.length} className="px-3 py-2 text-valley-gray text-sm font-medium">
                      <div className="flex items-center gap-2 text-valley-gray">
                        {school.school}
                        <div className={`${expandedSchools[schoolIndex] ? 'rotate-180' : 'rotate-0'} ${transitionClasses.arrowRotation}`}>
                          <ArrowDown />
                        </div>
                      </div>
                    </td>
                  </tr>

                  {expandedSchools[schoolIndex] &&
                    school.schedule.map((row, rowIndex) => (
                      <tr key={rowIndex} className={`bg-white hover:bg-gray-50 align-top text-sm text-black font-medium ${transitionClasses.rowHover}`}>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.teacher}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.disciplineCode}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.disciplineName}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.specialties}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.lessonType}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.day}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.time}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words">{row.auditorium}</td>
                        <td className="px-3 py-2 border-b align-top whitespace-normal break-words text-center">{row.count}</td>
                        <td className="px-3 py-2 border-b align-top">
                          {renderButtons(row)}
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              ))} */}
            </tbody>
          </table>
        </div>
      </div>

      {/* Мобильная версия (карточки) */}
      {/* <div className="lg:hidden mt-4 space-y-4 max-h-[70vh] overflow-y-auto text-black">
        {processedData.map((school, schoolIndex) => (
          <div key={schoolIndex} className="bg-white rounded-lg shadow overflow-hidden">
            <div
              className={`bg-gray-100 px-4 py-3 font-semibold cursor-pointer hover:bg-gray-200 flex justify-between items-center ${transitionClasses.rowHover}`}
              onClick={() => toggleSchool(schoolIndex)}
            >
              <span className="truncate pr-3">{school.school}</span>
              <span>
                <div className={`${expandedSchools[schoolIndex] ? 'rotate-180' : 'rotate-0'} ${transitionClasses.arrowRotation}`}>
                  <ArrowDown />
                </div>
              </span>
            </div>

            {expandedSchools[schoolIndex] && (
              <div className="divide-y">
                {school.schedule.map((row, rowIndex) => (
                  <div key={rowIndex} className="p-4 space-y-3 text-sm">
                    <div>
                      <span className="font-semibold text-gray-600">Преподаватель:</span>
                      <div className="mt-1">{row.teacher}</div>
                    </div>

                    <div className="grid grid-cols-1 xs:grid-cols-2 gap-3">
                      <div>
                        <span className="font-semibold text-gray-600">Шифр дисциплины:</span>
                        <div className="mt-1">{row.disciplineCode}</div>
                      </div>
                      <div>
                        <span className="font-semibold text-gray-600">Тип занятия:</span>
                        <div className="mt-1">{row.lessonType}</div>
                      </div>
                    </div>

                    <div>
                      <span className="font-semibold text-gray-600">Название дисциплины:</span>
                      <div className="mt-1">{row.disciplineName}</div>
                    </div>

                    <div>
                      <span className="font-semibold text-gray-600">Специальности:</span>
                      <div className="mt-1">{row.specialties}</div>
                    </div>

                    <div className="grid grid-cols-1 xs:grid-cols-2 gap-3">
                      <div>
                        <span className="font-semibold text-gray-600">День недели:</span>
                        <div className="mt-1">{row.day}</div>
                      </div>
                      <div>
                        <span className="font-semibold text-gray-600">Время:</span>
                        <div className="mt-1">{row.time}</div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 xs:grid-cols-2 gap-3">
                      <div>
                        <span className="font-semibold text-gray-600">Аудитория:</span>
                        <div className="mt-1">{row.auditorium}</div>
                      </div>
                      <div>
                        <span className="font-semibold text-gray-600">Количество студентов:</span>
                        <div className="mt-1">{row.count}</div>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-2 pt-2">
                      <button
                        type="button"
                        className={`flex-1 px-3 py-2 text-sm rounded bg-blue-600 text-white hover:bg-blue-700 ${transitionClasses.buttonHover}`}
                        onClick={() => onEdit ? onEdit(row) : console.log('edit', row)}
                      >
                        Редактировать
                      </button>
                      <button
                        type="button"
                        className={`flex-1 px-3 py-2 text-sm rounded bg-red-600 text-white hover:bg-red-700 ${transitionClasses.buttonHover}`}
                        onClick={() => onDelete ? onDelete(row) : console.log('delete', row)}
                      >
                        Удалить
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div> */}
    </div>
  );
}